var _rect, _path, _path2, _rect2, _path3, _rect3, _rect4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Buyer Flow"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-19239 -12665C-19239 -12666.1 -19238.1 -12667 -19237 -12667H3927C3928.11 -12667 3929 -12666.1 3929 -12665V1898C3929 1899.1 3928.11 1900 3927 1900H-19237C-19238.1 1900 -19239 1899.1 -19239 1898V-12665Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-19237 -12666H3927V-12668H-19237V-12666ZM3928 -12665V1898H3930V-12665H3928ZM3927 1899H-19237V1901H3927V1899ZM-19238 1898V-12665H-19240V1898H-19238ZM-19237 1899C-19237.6 1899 -19238 1898.55 -19238 1898H-19240C-19240 1899.66 -19238.7 1901 -19237 1901V1899ZM3928 1898C3928 1898.55 3927.55 1899 3927 1899V1901C3928.66 1901 3930 1899.66 3930 1898H3928ZM3927 -12666C3927.55 -12666 3928 -12665.6 3928 -12665H3930C3930 -12666.7 3928.66 -12668 3927 -12668V-12666ZM-19237 -12668C-19238.7 -12668 -19240 -12666.7 -19240 -12665H-19238C-19238 -12665.6 -19237.6 -12666 -19237 -12666V-12668Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Setting",
    clipPath: "url(#clip0_394_3244)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 1484,
    transform: "translate(-605 -858)",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624223",
    d: "M-165 -778H774V131H-165V-778Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171275325"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -144.5,
    y: -11.5,
    width: 182,
    height: 47,
    rx: 7.5,
    stroke: "#EB5757"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_394_3244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_394_3244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logout_2",
    d: "M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H12V5H5V19H12V21H5ZM16 17L14.625 15.55L17.175 13H9V11H17.175L14.625 8.45L16 7L21 12L16 17Z",
    fill: "#EB5757"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_3244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 1484,
    fill: "white",
    transform: "translate(-605 -858)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1098387239ae38ae6c8f39f9814e3d97.svg";
export { ForwardRef as ReactComponent };